export default __webpack_public_path__ + "static/media/video_teal.457171d3.svg";